// code for this was borrowed from https://css-tricks.com/lets-create-a-custom-audio-player/
// Jonathan - Nov 2021

const formatTime = (rawSeconds) => {
  const minutes = Math.floor(rawSeconds / 60);
  const seconds = Math.floor(rawSeconds % 60);
  const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${minutes}:${returnedSeconds}`;
};

export default () => {
  document.querySelectorAll(".js-audio-player").forEach((el) => {
    const audioButton = el.querySelector(".js-audio-player-button");
    const audioElement = el.querySelector(".js-audio-player-source");
    const audioPause = "audio-is-paused";
    const audioPlay = "audio-is-playing";

    // optional seek progress bar
    const audioSeek = el.querySelector(".js-audio-player__seek");
    const audioDuration = el.querySelector(".js-audio-player__duration");
    const audioCurrentTime = el.querySelector(".js-audio-player__current-time");
    const audioSlider = el.querySelector(".js-audio-player__range");

    let rAF = null;

    init();

    function init() {
      setTimeout(() => {
        audioElement.paused
          ? el.classList.add(audioPause)
          : el.classList.add(audioPlay);
      }, 10);

      if (audioElement.readyState > 0) {
        if (audioSeek) {
          initSeekSlider();
        }
      } else {
        if (audioSeek) {
          audioElement.addEventListener("loadedmetadata", initSeekSlider);
        }
      }

      bindEvents();
    }

    function initSeekSlider() {
      audioElement.removeEventListener("loadedmetadata", initSeekSlider);
      displayDuration();
      setSliderMax();
      displayBufferedAmount();

      // As the audio player
      audioElement.addEventListener("progress", displayBufferedAmount);
    }

    function bindEvents() {
      audioButton.addEventListener("click", (e) => {
        if (audioElement.paused) {
          play();
        } else {
          pause();
        }
      });

      audioElement.addEventListener("ended", pause);
      audioElement.addEventListener("play", play);
      audioElement.addEventListener("pause", pause);

      if (audioSeek) {
        // clicking on the seeker
        audioSlider.addEventListener("input", () => {
          setCurrentTime();
          showRangeProgress();
          if (!audioElement.paused) {
            cancelAnimationFrame(rAF);
          }
        });
        // sliding the seeker
        audioSlider.addEventListener("change", () => {
          audioElement.currentTime = audioSlider.value;
          if (!audioElement.paused) {
            requestAnimationFrame(whilePlaying);
          }
        });
      }
    }

    function play() {
      el.classList.remove(audioPause);
      el.classList.add(audioPlay);
      audioElement.play();

      if (audioSeek) {
        window.requestAnimationFrame(whilePlaying);
      }
    }

    function pause() {
      el.classList.remove(audioPlay);
      el.classList.add(audioPause);
      audioElement.pause();

      if (audioSeek) {
        window.cancelAnimationFrame(rAF);
      }
    }

    function displayDuration() {
      audioDuration.textContent = formatTime(audioElement.duration);
    }

    function displayBufferedAmount() {
      // safari doesn't seem to buffer
      // .end() cannot except 0
      if (audioElement.buffered.length === 0) {
        return;
      }
      const bufferedAmount = Math.floor(
        audioElement.buffered.end(audioElement.buffered.length - 1),
      );

      el.style.setProperty(
        "--buffered-width",
        `${(bufferedAmount / audioSlider.max) * 100}%`,
      );
    }

    function whilePlaying() {
      audioSlider.value = Math.floor(audioElement.currentTime);
      setCurrentTime();
      showRangeProgress();
      rAF = requestAnimationFrame(whilePlaying);
    }

    function setSliderMax() {
      audioSlider.max = Math.floor(audioElement.duration);
    }

    function setCurrentTime() {
      audioCurrentTime.textContent = formatTime(audioSlider.value);
    }

    function showRangeProgress() {
      el.style.setProperty(
        "--seek-before-width",
        (audioSlider.value / audioSlider.max) * 100 + "%",
      );
    }
  });
};
